import login from "./login";
import register from "./register";
import forgotPassword from "./forgotPassword";
import passwordReset from "./passwordReset";
import emailConfirmation from "./emailConfirmation";
import checkInbox from "./checkInbox";
import logout from "./logout";
import welcome from "./welcome";

export default {
  login,
  register,
  forgotPassword,
  passwordReset,
  emailConfirmation,
  checkInbox,
  logout,
  welcome
};
